module.exports = __webpack_public_path__ + "static/media/icon.d358293f.svg";